export const APIKEYPARAM = `?api_key=${process.env.REACT_APP_API_KEY}`;
export const BASEURL = "https://api.themoviedb.org/3/movie/";
